// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import cmtmemEntity from './entities/cmtmem.json';
import cmtmemMenu from '../pages/cmtmem/menu.json';
import cmtmemFullForm from '../pages/cmtmem/forms/full.json';
import cmtmemContextForm from '../pages/cmtmem/forms/context.json';
import cmtmemMiniForm from '../pages/cmtmem/forms/mini.json';
import cmtmemLookupForm from '../pages/cmtmem/forms/lookup.json';
import cmtmemTableView from '../pages/cmtmem/views/table.json';
import cmtmemStagesView from '../pages/cmtmem/views/stages.json';
import cmtmemCardsView from '../pages/cmtmem/views/cards.json';
import cmtmemInlineView from '../pages/cmtmem/views/inline.json';
import cmtmemBacklogView from '../pages/cmtmem/views/backlog.json';
import cmtmemSplitView from '../pages/cmtmem/views/split.json';
import cmtmemCalendarView from '../pages/cmtmem/views/calendar.json';
import cmtmemDashboardView from '../pages/cmtmem/views/dashboard.json';

/** Тип запису «Член комітету» зі сторінками пакета: меню, форми та подання з pages/cmtmem/. */
export const cmtmemDefinition: IRecordTypeDefinition = {
  ...cmtmemEntity,
  views: assembleViewSet({
      table: cmtmemTableView,
      stages: cmtmemStagesView,
      cards: cmtmemCardsView,
      inline: cmtmemInlineView,
      backlog: cmtmemBacklogView,
      split: cmtmemSplitView,
      calendar: cmtmemCalendarView,
      dashboard: cmtmemDashboardView,
  }),
  form: cmtmemFullForm,
  forms: { full: cmtmemFullForm, context: cmtmemContextForm, mini: cmtmemMiniForm, lookup: cmtmemLookupForm },
  menu: cmtmemMenu,
} as IRecordTypeDefinition;
